module.exports = __webpack_public_path__ + "img/file-approval-history.8e814541.png";